let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6BZbQ")).then(() => parcelRequire('e4V1k'));